export default __webpack_public_path__ + "static/media/goodMeter.bf5f4126.svg";